import EverTrue from "app";
import BaseRouter from "base/base-router";
import FeatureStore from "apps/layout/stores/feature-store";
import JourneyDetailController from "./controllers/journey-detail-controller";
import { fetchAllJourneysForAllJourneyGroups } from "apps/journeys/utils/api-requests/journey-index";
import EmptyStateMessage from "components/lists/empty-state-message";
// import JourneyIndexController from "./controllers/journey-index-controller";
import IsGatedController from "components/gates/is-gated-controller";

class JourneysRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      "cadences(/)": "index",
      "cadences/:id": "journey",
    };
  }

  // ALL Journeys
  // (TODO: This view does not exist yet, so we just hard-redirect them to the detailed view for the first journey);
  async index() {
    const journeysListResponse = await fetchAllJourneysForAllJourneyGroups();
    if (journeysListResponse && journeysListResponse.length) {
      const [{ id } = {}] = journeysListResponse; // grab the first journey
      EverTrue.Navigator(`/cadences/${id}`, true); // hard redirect them to the journey(id) function below
    } else {
      this.currentView = (
        <EmptyStateMessage icon="ban" text={"Your organization does not appear to have any cadences!"} />
      );
      EverTrue.page.mount(this.currentView);
    }
    // This is the eventual desired behavior: show a list of all journeys
    // comment out the code above and replace it with this, when we build the JourneyIndexController
    // EverTrue.track.set("cadences", { type: "left_nav" });
    // EverTrue.execute("setBrowserTitle", "Cadences");
    // this.currentView = (
    //   <IsGatedController gate="cadences">
    //     <JourneyIndexController />
    //   </IsGatedController>
    // );
    // EverTrue.page.mount(this.currentView);
  }
  // ONE Journey
  journey(id) {
    if (FeatureStore.hasFeature("unreleased_feature")) {
      EverTrue.track.set("cadences", { type: "left_nav" }); // TODO
      EverTrue.execute("setBrowserTitle", "Cadences");
      this.currentView = (
        <IsGatedController gate="cadences">
          <JourneyDetailController journeyId={id} />;
        </IsGatedController>
      );
      EverTrue.page.mount(this.currentView);
    } else EverTrue.Navigator("/contact", true);
  }
}

JourneysRouter.initClass();
export default JourneysRouter;
